/**
 * @generated SignedSource<<1e39799190dae3de9e17bd0fc75852cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusWidgetWithoutAccess$data = {
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetDailyPulseQuery" | "plusWidgetHighlightsQuery" | "plusWidgetNewsAgendaQuery">;
  readonly " $fragmentType": "plusWidgetWithoutAccess";
};
export type plusWidgetWithoutAccess$key = {
  readonly " $data"?: plusWidgetWithoutAccess$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetWithoutAccess">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dailyPulseTypeUuId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "highlightQueueName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaEndDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaStartDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaTypes"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusWidgetWithoutAccess",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "dailyPulseTypeUuId",
          "variableName": "dailyPulseTypeUuId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetDailyPulseQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "queueName",
          "variableName": "highlightQueueName"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetHighlightsQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "applicationId",
          "variableName": "applicationId"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaEndDate",
          "variableName": "plusNewsAgendaEndDate"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaStartDate",
          "variableName": "plusNewsAgendaStartDate"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaTypes",
          "variableName": "plusNewsAgendaTypes"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetNewsAgendaQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "cd416268160552b6f99afcb2c7cfb35d";

export default node;
